import React, { useEffect, useState } from "react";
import Footer from "ThemeLayout/footer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "Slices/theme/store";
import bannerImg from "../../assets/images/banner/02.png";
import bannerBg from "../../assets/images/banner/01.jpg";
import { useNavigate } from "react-router-dom";
import { handlingApi } from "units/handlingApi";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { changeAuthenticated } from "Slices/theme/reducer";
import ChangePassword from "ThemeLayout/ChangePassword";

const Profile: React.FC = () => {
  const [deleteConfirm, setDeleteConfirm] = useState<string>("");
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.theme.user);

  // State for controlling the Change Password popup
  const [showChangePassword, setShowChangePassword] = useState(false);

  // Controlled state for password fields in the popup
  const [passwords, setPasswords] = useState({
    // oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // Handle changes for password fields
  const handlePasswordChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  const onClose = () => {
    setShowChangePassword(false);
    setError(null);
    setPasswords({
      // oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  // Handle submission of the change password form
  const handlePasswordSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    // Validate that new password and confirmation match
    if (passwords.newPassword !== passwords.confirmPassword) {
      setError("Das neue Passwort und die Bestätigung stimmen nicht überein.");
      return;
    }
    setError(null);
    try {
      setLoading(true);
      const url = `${process.env.REACT_APP_API_BASE_URL}user/change-password`;
      const token = Cookies.get("token");
      const data = {
        // oldPassword: passwords.oldPassword,
        newPassword: passwords.newPassword,
      };
      const res = await handlingApi({ url, method: "POST", data, token });
      if (res.statusCode === 200) {
        toast.success(res.message);
        setShowChangePassword(false);
        // Clear password fields on success
        setPasswords({
          // oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        toast.error(res.message || "Error changing password");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/");
    }
  }, []);

  const handleDeleteUser = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowDeleteConfirmation(true);
  };

  const confirmDeleteUser = async () => {
    if (deleteConfirm !== "delete") {
      toast.error("Please type 'delete' to confirm deletion.");
      return;
    }
    setLoading(true);
    const token = Cookies.get("token");
    const url = `${process.env.REACT_APP_API_BASE_URL}user/delete`;
    const res = await handlingApi({ url, method: "DELETE", data: {}, token });
    if (res.statusCode === 200) {
      dispatch(changeAuthenticated(false));
      localStorage.removeItem("userData");
      Cookies.remove("token");
      setLoading(false);
      navigate("/");
      toast.success(res.message);
    } else {
      setLoading(false);
    }
    setShowDeleteConfirmation(false);
  };

  const cancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  return (
    <>
      <div className="container-custom mb-5 pb-4">
        <div className="row">
          <div className="col-lg-12">
            <div className="user-profile-inner">
              <h4 className="title">User Profile</h4>
              <div className="user-profile-main-wrapper">
                <div className="thumbnaiul">
                  {/* <img src={bannerBg} alt="iamges" /> */}
                  <div className="profile-image">
                    <img src={bannerImg} alt="banner_image" />
                  </div>
                </div>
                <div className="user-profile-content-details">
                  <form action="#">
                    <div className="half-input-wrapper">
                      <div className="single">
                        <label htmlFor="f-name">First Name</label>
                        <input
                          id="f-name"
                          type="text"
                          placeholder=""
                          value={user?.fName}
                          readOnly
                        />
                      </div>
                      <div className="single">
                        <label htmlFor="l-name">Last Name</label>
                        <input
                          id="l-name"
                          type="text"
                          placeholder="Adam Jon"
                          value={user?.lName}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="half-input-wrapper pt-0">
                      <div className="single">
                        <label htmlFor="email">Email/Number</label>
                        <input
                          id="email"
                          type="email"
                          placeholder="Email Number"
                          value={user?.email}
                          readOnly
                        />
                      </div>
                      <div className="single">
                        {/* <label htmlFor="phonenumber">Phone Number</label>
                        <input id="phonenumber" type="text" readOnly /> */}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        style={{
                          width: "fit-content",
                          color: "blue",
                          textDecoration: "underline",
                        }}
                        className="btn fs-4 mb-0"
                        onClick={() => setShowChangePassword(true)}
                      >
                        Change Password
                      </p>
                      <button
                        style={{ minWidth: "unset" }}
                        className="rts-btn border-0 btn-danger"
                        onClick={handleDeleteUser}
                      >
                        Delete Account
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Account Confirmation Modal */}
      {showDeleteConfirmation && (
        <div
          className="confirmation-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="confirmation-modal"
            style={{
              backgroundColor: "white",
              padding: "2rem",
              borderRadius: "0.5rem",
              maxWidth: "500px",
              width: "100%",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3 className="mb-3">Confirm Account Deletion</h3>
            <p className="mb-3">
              Are you sure you want to delete your account? Type <b>delete</b>{" "}
              to confirm.
            </p>
            <input
              style={{ borderRadius: "10px" }}
              type="text"
              className="mb-4 py-2 border"
              onChange={(e) => setDeleteConfirm(e.target.value)}
            />
            <div className="d-flex justify-content-end gap-3">
              <button className="rts-btn btn-secondary" onClick={cancelDelete}>
                Cancel
              </button>
              <button
                className="rts-btn btn-danger"
                onClick={confirmDeleteUser}
              >
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showChangePassword && (
        <ChangePassword
          onClose={onClose}
          passwords={passwords}
          onSubmit={handlePasswordSubmit}
          loading={loading}
          error={error}
          handlePasswordChange={handlePasswordChange}
        />
      )}

      <Footer />
    </>
  );
};

export default Profile;
